export default __webpack_public_path__ + "static/media/red-path.ee216418.svg";